/**
 * Apples Wetterschlüssel — als Wort und als Symbol.
 *
 * **Beides steht hier, und das ist der Punkt.** Die Kachel im Kartenstapel
 * zeigt ein Zeichen, das Blatt dahinter ein Wort; stünde die Zuordnung an zwei
 * Stellen, zeigte die Kachel irgendwann eine Sonne und das Blatt „Nieselregen".
 * Wer einen Schlüssel ergänzt, ergänzt ihn zwangsläufig für beide.
 *
 * Aufgeführt sind nur die häufigen. Was hier nicht steht, wird als Wort
 * **durchgereicht** und bekommt **kein** Symbol: Apple ergänzt die Liste, ohne
 * zu fragen, und ein erfundenes Zeichen wäre schlimmer als keines — ein
 * unbekannter Schlüssel ist wenigstens als solcher zu erkennen.
 */

/** Die acht Zeichen, die es gibt. `null` heißt: keines, nur die Temperatur. */
export type Lage =
  | 'klar'
  | 'teils'
  | 'wolkig'
  | 'regen'
  | 'schnee'
  | 'gewitter'
  | 'nebel'
  | 'wind'

interface Eintrag {
  wort: string
  lage: Lage
}

const SCHLUESSEL: Record<string, Eintrag> = {
  Clear: { wort: 'klar', lage: 'klar' },
  MostlyClear: { wort: 'überwiegend klar', lage: 'klar' },
  PartlyCloudy: { wort: 'teils bewölkt', lage: 'teils' },
  MostlyCloudy: { wort: 'überwiegend bewölkt', lage: 'wolkig' },
  Cloudy: { wort: 'bewölkt', lage: 'wolkig' },
  Drizzle: { wort: 'Nieselregen', lage: 'regen' },
  Rain: { wort: 'Regen', lage: 'regen' },
  HeavyRain: { wort: 'starker Regen', lage: 'regen' },
  Snow: { wort: 'Schnee', lage: 'schnee' },
  Sleet: { wort: 'Schneeregen', lage: 'schnee' },
  Hail: { wort: 'Hagel', lage: 'schnee' },
  Thunderstorms: { wort: 'Gewitter', lage: 'gewitter' },
  Foggy: { wort: 'Nebel', lage: 'nebel' },
  Haze: { wort: 'Dunst', lage: 'nebel' },
  Windy: { wort: 'windig', lage: 'wind' },
  Breezy: { wort: 'frischer Wind', lage: 'wind' },
}

/** Der Schlüssel auf Deutsch — oder er selbst, wenn wir ihn nicht kennen. */
export function beschreibe(code: string): string {
  return SCHLUESSEL[code]?.wort ?? code
}

/** Welches Zeichen dazugehört — `null`, wenn wir den Schlüssel nicht kennen. */
export function lageVon(code: string): Lage | null {
  return SCHLUESSEL[code]?.lage ?? null
}
